<template>
  <div class="runs-list">
    <div v-if="loading" class="loading">Loading tasks...</div>
    <div v-else-if="taskList && taskList.length > 0" class="tasks-container">
      <TaskCard
        v-for="task in taskList"
        :key="task.id"
        :session="task"
        :permissions="{ trainer_write: true }"
        :show-icons="true"
        @delete-session="handleTaskDeleted"
      />
    </div>
    <div v-else class="empty-state">
      No tasks available
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import TaskCard from '@/components/Apps/TaskCard.vue';

const props = defineProps({
  train_session_id: {
    type: [String, Number],
    required: false,
  },
  val_session_id: {
    type: [String, Number],
    required: false,
  },
});

const taskList = ref([]);
const loading = ref(false);
const dataConnect = new DatastoreConnect();

const fetchTasks = async () => {

  let args=null;
  if (props.train_session_id) {
    args={train_session_id: Number(props.train_session_id)};
  } 
  if (props.val_session_id) {
    args={val_session_id: Number(props.val_session_id)};
  }

  if (!args) {
    console.warn('No session ID provided for fetching tasks.');
    return;
    }
  
  loading.value = true;
  try {
    const response = await dataConnect.api('task.list', args);
    
    if (response && response.result) {
      taskList.value = response.result.tasks || [];
    } else {
      taskList.value = [];
    }
  } catch (error) {
    console.error('Error fetching tasks:', error);
    taskList.value = [];
  } finally {
    loading.value = false;
  }
};

watch(
  () => [props.train_session_id, props.val_session_id],
  () => {
    if (props.train_session_id || props.val_session_id) {
      fetchTasks();
    }
  }
);

onMounted(() => {
  fetchTasks();
});

const handleTaskDeleted = () => {
  // Refresh the task list when a task is deleted
  fetchTasks();
};
</script>

<style lang="scss" scoped>
.runs-list {
  padding: 16px;
}

.loading {
  text-align: center;
  padding: 20px;
  color: var(--body-text-color-secondary);
}

.tasks-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--body-text-color-secondary);
}
</style>
